import methodAPI from "../Dashboard/Handlers/methodAPI";
import publicAPI from "../Dashboard/Handlers/publicAPI";

export const adminCouponAPI = {
  list: async () => methodAPI.get('/coupons_list'),
  create: async (data) => methodAPI.post('/coupons_create', data),

  // apply with debug logging
  apply: async (data) => {
    console.debug('adminCouponAPI.apply request', data);
    try {
      const res = await publicAPI.post('/apply-coupon', data);
      console.debug('adminCouponAPI.apply response', res.data);
      return res.data;
    } catch (err) {
      console.debug('adminCouponAPI.apply error', err && err.response ? err.response.data : err);
      throw err;
    }
  }
};
